import { TrackTargetSelector } from './TrackTargetSelector'

export default TrackTargetSelector
